const toggle=document.querySelector('.menu-toggle');const nav=document.querySelector('.site-header nav');const menuClose=document.querySelector('.menu-close');const menuOverlay=document.querySelector('.menu-overlay');const setMenu=open=>{nav?.classList.toggle('open',open);menuOverlay?.classList.toggle('open',open);document.body.classList.toggle('menu-open',open);toggle?.setAttribute('aria-expanded',String(open))};toggle?.addEventListener('click',()=>setMenu(!nav?.classList.contains('open')));menuClose?.addEventListener('click',()=>setMenu(false));menuOverlay?.addEventListener('click',()=>setMenu(false));nav?.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>setMenu(false)));document.addEventListener('keydown',event=>{if(event.key==='Escape')setMenu(false)});
document.addEventListener('click',event=>{if(event.target.closest('.cart-toast'))window.location.href=window.Shopify?`${window.Shopify.routes?.root||'/'}cart`:'cart.html'});
const plannedWordmarks=[...document.querySelectorAll('.planned-image-wrap')];plannedWordmarks.forEach(wordmark=>wordmark.classList.add('planned-writing-pending'));if('IntersectionObserver'in window){const plannedObserver=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(!entry.isIntersecting)return;entry.target.classList.add('is-writing');entry.target.classList.remove('planned-writing-pending');plannedObserver.unobserve(entry.target)})},{threshold:.35});plannedWordmarks.forEach(wordmark=>plannedObserver.observe(wordmark))}else{plannedWordmarks.forEach(wordmark=>{wordmark.classList.add('is-writing');wordmark.classList.remove('planned-writing-pending')})}
document.querySelectorAll('.collection').forEach(section=>{const track=section.querySelector('.product-grid');const previous=section.querySelector('.carousel-prev');const next=section.querySelector('.carousel-next');const scrollOne=direction=>{const card=track?.querySelector('.product-card');if(!track||!card)return;const gap=parseFloat(getComputedStyle(track).gap)||16;track.scrollTo({left:track.scrollLeft+direction*(card.getBoundingClientRect().width+gap),behavior:'smooth'})};const updateArrows=()=>{if(!track)return;if(previous)previous.disabled=track.scrollLeft<4;if(next)next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-4};previous?.addEventListener('click',()=>scrollOne(-1));next?.addEventListener('click',()=>scrollOne(1));track?.addEventListener('scroll',updateArrows,{passive:true});window.addEventListener('resize',updateArrows);updateArrows()});
document.querySelectorAll('.campaign-animation').forEach(animation=>{const button=animation.closest('.film-media')?.querySelector('.film-badge');const label=button?.querySelector('.film-action-label');button?.addEventListener('click',()=>{const animationSource=animation.dataset.animation;const finalFrame=animation.dataset.finalFrame;if(!animationSource||!finalFrame)return;button.disabled=true;if(label)label.textContent='Lejátszás…';animation.src=`${animationSource}?play=${Date.now()}`;window.setTimeout(()=>{animation.src=finalFrame;button.disabled=false;if(label)label.textContent='Újra lejátszás'},4500)})});



document.querySelectorAll('.product-gallery').forEach(gallery => {
  const main = gallery.querySelector('.product-image img');
  const imageFrame = gallery.querySelector('.product-image');
  const strip = gallery.querySelector('.gallery-thumbnails');
  const thumbs = [...gallery.querySelectorAll('.gallery-thumb')];
  const previous = gallery.querySelector('.gallery-prev');
  const next = gallery.querySelector('.gallery-next');
  if (!main || !imageFrame || !strip || !previous || !next || !thumbs.length) return;
  let selected = 0;
  let imageChangeTimer;
  const select = index => {
    selected = Math.max(0, Math.min(thumbs.length - 1, index));
    const thumb = thumbs[selected];
    const image = thumb.querySelector('img');
    const nextSource = image.getAttribute('src');
    if (main.getAttribute('src') !== nextSource) {
      window.clearTimeout(imageChangeTimer);
      main.classList.add('is-changing');
      imageChangeTimer = window.setTimeout(() => {
        main.src = nextSource;
        main.alt = image.alt;
        requestAnimationFrame(() => requestAnimationFrame(() => main.classList.remove('is-changing')));
      }, 150);
    }
    thumbs.forEach((button, i) => button.setAttribute('aria-pressed', String(i === selected)));
    previous.disabled = selected === 0;
    next.disabled = selected === thumbs.length - 1;
    gallery.querySelector('.gallery-status').textContent = `${selected + 1} / ${thumbs.length} · ${thumb.getAttribute('aria-label')}`;
    strip.scrollTo({left: thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.clientWidth) / 2, behavior: 'smooth'});
  };
  thumbs.forEach((button, i) => button.addEventListener('click', () => select(i)));
  previous.addEventListener('click', () => select(selected - 1));
  next.addEventListener('click', () => select(selected + 1));
  gallery.addEventListener('keydown', event => {
    if (!['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
    event.preventDefault();
    select(selected + (event.key === 'ArrowRight' ? 1 : -1));
    thumbs[selected].focus({preventScroll: true});
  });
  let start;
  let lastSwipe = 0;
  main.addEventListener('touchstart', event => {start = {x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY};}, {passive: true});
  main.addEventListener('touchend', event => {
    if (!start) return;
    const dx = event.changedTouches[0].clientX - start.x;
    const dy = event.changedTouches[0].clientY - start.y;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) {
      lastSwipe = Date.now();
      select(selected + (dx < 0 ? 1 : -1));
    }
    start = null;
  }, {passive: true});

  const lightbox = document.createElement('div');
  lightbox.className = 'image-lightbox';
  lightbox.hidden = true;
  lightbox.setAttribute('role', 'dialog');
  lightbox.setAttribute('aria-modal', 'true');
  lightbox.setAttribute('aria-label', 'Nagyított termékkép');
  const lightboxImage = document.createElement('img');
  lightboxImage.className = 'image-lightbox__image';
  const lightboxPrevious = document.createElement('button');
  lightboxPrevious.type = 'button';
  lightboxPrevious.className = 'image-lightbox__prev';
  lightboxPrevious.setAttribute('aria-label', 'Előző kép');
  lightboxPrevious.textContent = '←';
  const lightboxNext = document.createElement('button');
  lightboxNext.type = 'button';
  lightboxNext.className = 'image-lightbox__next';
  lightboxNext.setAttribute('aria-label', 'Következő kép');
  lightboxNext.textContent = '→';
  const closeButton = document.createElement('button');
  closeButton.type = 'button';
  closeButton.className = 'image-lightbox__close';
  closeButton.setAttribute('aria-label', 'Nagyított kép bezárása');
  closeButton.textContent = '×';
  lightbox.append(lightboxPrevious, lightboxImage, lightboxNext, closeButton);
  document.body.appendChild(lightbox);

  const zoomButton = document.createElement('button');
  zoomButton.type = 'button';
  zoomButton.className = 'gallery-zoom';
  zoomButton.setAttribute('aria-label', 'Kép nagyítása');
  zoomButton.textContent = '⌕';
  imageFrame.appendChild(zoomButton);

  let lightboxChangeTimer;
  const updateLightboxImage = animate => {
    const image = thumbs[selected].querySelector('img');
    const applyImage = () => {
      lightboxImage.src = image.getAttribute('src');
      lightboxImage.alt = image.alt;
      requestAnimationFrame(() => requestAnimationFrame(() => lightboxImage.classList.remove('is-changing')));
    };
    lightboxPrevious.disabled = selected === 0;
    lightboxNext.disabled = selected === thumbs.length - 1;
    window.clearTimeout(lightboxChangeTimer);
    if (!animate) {
      applyImage();
      return;
    }
    lightboxImage.classList.add('is-changing');
    lightboxChangeTimer = window.setTimeout(applyImage, 150);
  };
  const navigateLightbox = direction => {
    const previousIndex = selected;
    select(selected + direction);
    if (selected !== previousIndex) updateLightboxImage(true);
  };
  const openLightbox = () => {
    updateLightboxImage(false);
    lightbox.hidden = false;
    document.body.classList.add('image-lightbox-open');
    requestAnimationFrame(() => lightbox.classList.add('is-open'));
    closeButton.focus({preventScroll:true});
  };
  const closeLightbox = () => {
    lightbox.classList.remove('is-open');
    document.body.classList.remove('image-lightbox-open');
    window.setTimeout(() => { lightbox.hidden = true; }, 280);
    zoomButton.focus({preventScroll:true});
  };
  main.tabIndex = 0;
  main.setAttribute('role', 'button');
  main.setAttribute('aria-label', 'Kép nagyítása');
  main.addEventListener('click', () => { if (Date.now() - lastSwipe > 500) openLightbox(); });
  main.addEventListener('keydown', event => {
    if (!['Enter', ' '].includes(event.key)) return;
    event.preventDefault();
    openLightbox();
  });
  zoomButton.addEventListener('click', openLightbox);
  lightboxPrevious.addEventListener('click', () => navigateLightbox(-1));
  lightboxNext.addEventListener('click', () => navigateLightbox(1));
  closeButton.addEventListener('click', closeLightbox);
  lightbox.addEventListener('click', event => { if (event.target === lightbox) closeLightbox(); });
  let lightboxTouchX;
  lightbox.addEventListener('touchstart', event => { lightboxTouchX = event.changedTouches[0].clientX; }, {passive:true});
  lightbox.addEventListener('touchend', event => {
    if (lightboxTouchX === undefined) return;
    const distance = event.changedTouches[0].clientX - lightboxTouchX;
    if (Math.abs(distance) > 45) navigateLightbox(distance < 0 ? 1 : -1);
    lightboxTouchX = undefined;
  }, {passive:true});
  document.addEventListener('keydown', event => {
    if (lightbox.hidden) return;
    if (event.key === 'Escape') closeLightbox();
    if (event.key === 'ArrowLeft') { event.preventDefault(); navigateLightbox(-1); }
    if (event.key === 'ArrowRight') { event.preventDefault(); navigateLightbox(1); }
  });
});

// Keep the original wordmark as the accessible image; animate decorative copies only.
document.querySelectorAll('.site-header .wordmark').forEach(wordmark => {
  const original = wordmark.querySelector('img');
  if (!original || wordmark.classList.contains('wordmark-written')) return;
  const draw = () => {
    if (!original.naturalWidth) return;
    ['wordmark-stroke', 'wordmark-dot'].forEach(className => {
      const layer = original.cloneNode(false);
      layer.className = className;
      layer.alt = '';
      layer.setAttribute('aria-hidden', 'true');
      wordmark.appendChild(layer);
    });
    wordmark.classList.add('wordmark-written');
  };
  if (original.complete) draw();
  else original.addEventListener('load', draw, {once:true});
});

// Keep the announcement readable as one sentence while its halves enter together.
document.querySelectorAll('.announcement').forEach(bar => {
  const words = bar.textContent.trim().split(/\s+/);
  if (words.length < 2) return;
  const middle = Math.ceil(words.length / 2);
  const line = document.createElement('span');
  line.className = 'announcement-line';
  const left = document.createElement('span');
  left.className = 'announcement-left';
  left.textContent = words.slice(0, middle).join(' ');
  const right = document.createElement('span');
  right.className = 'announcement-right';
  right.textContent = words.slice(middle).join(' ');
  line.append(left, document.createTextNode(' '), right);
  bar.replaceChildren(line);
});

// Resume a muted background film when it becomes visible; respect browser policy.
document.querySelectorAll('.campaign-video').forEach(video => {
  const start = () => {
    if (document.visibilityState === 'hidden') return;
    video.muted = true;
    const play = video.play();
    if (play) play.catch(() => {});
  };
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) start();
    }, {threshold:0.05});
    observer.observe(video);
  }
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') start();
  });
  document.addEventListener('pointerdown', start, {once:true, passive:true});
});

// Collapse only the mobile biography; keep desktop and no-script content complete.
document.querySelectorAll('.about-copy').forEach(copy => {
  const button = copy.querySelector('.about-toggle');
  const extra = copy.querySelector('.about-extra');
  if (!button || !extra) return;
  const mobile = window.matchMedia('(max-width:900px)');
  let expanded = false;
  const render = () => {
    button.hidden = !mobile.matches;
    extra.hidden = mobile.matches && !expanded;
    button.setAttribute('aria-expanded', String(!extra.hidden));
    button.textContent = expanded ? 'Kevesebb' : 'Tovább…';
  };
  button.addEventListener('click', () => { expanded = !expanded; render(); });
  mobile.addEventListener('change', render);
  render();
});

window.addEventListener('pageshow',()=>setMenu(false));
window.matchMedia('(min-width:901px)').addEventListener('change',event=>{if(event.matches)setMenu(false)});

// Update Shopify cart totals as soon as a quantity changes.
const pillanatMoney = cents => `${new Intl.NumberFormat('hu-HU').format(Math.round(cents / 100))} Ft`;
document.querySelectorAll('.cart-quantity-input').forEach(input => {
  let timer;
  const updateQuantity = () => {
    const line = Number(input.dataset.cartLine);
    const quantity = Math.max(0, Number.parseInt(input.value, 10) || 0);
    input.value = String(quantity);
    input.disabled = true;
    fetch(`${window.Shopify?.routes?.root || '/'}cart/change.js`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
      body: JSON.stringify({line, quantity})
    })
      .then(response => { if (!response.ok) throw new Error('Cart update failed'); return response.json(); })
      .then(cart => {
        if (quantity === 0) { window.location.reload(); return; }
        document.querySelectorAll('.cart-row').forEach((row, index) => {
          const item = cart.items[index];
          const total = row.querySelector('.cart-line-total');
          if (item && total) total.textContent = pillanatMoney(item.final_line_price);
        });
        const grandTotal = document.querySelector('.cart-total');
        if (grandTotal) grandTotal.textContent = pillanatMoney(cart.total_price);
        document.querySelectorAll('.bag span,.mobile-cart-link span').forEach(badge => { badge.textContent = String(cart.item_count); });
      })
      .catch(() => window.location.reload())
      .finally(() => { input.disabled = false; });
  };
  input.addEventListener('input', () => { window.clearTimeout(timer); timer = window.setTimeout(updateQuantity, 450); });
  input.addEventListener('change', () => { window.clearTimeout(timer); updateQuantity(); });
});

// Product-page quantity steppers.
document.querySelectorAll('[data-product-quantity]').forEach(picker => {
  const input = picker.querySelector('input[type="number"]');
  const minus = picker.querySelector('[data-quantity-minus]');
  const plus = picker.querySelector('[data-quantity-plus]');
  if (!input || !minus || !plus) return;

  const setQuantity = value => {
    const minimum = Math.max(1, Number.parseInt(input.min, 10) || 1);
    input.value = String(Math.max(minimum, Number.parseInt(value, 10) || minimum));
  };
  minus.addEventListener('click', () => setQuantity(Number(input.value) - 1));
  plus.addEventListener('click', () => setQuantity(Number(input.value) + 1));
  input.addEventListener('change', () => setQuantity(input.value));
});

// Add Shopify products without leaving the current page, then show the compact confirmation.
if (window.Shopify) {
  const shopifyToast = document.createElement('button');
  shopifyToast.type = 'button';
  shopifyToast.className = 'cart-toast';
  shopifyToast.setAttribute('aria-label', 'Kosár megnyitása');
  shopifyToast.setAttribute('aria-live', 'polite');
  document.body.appendChild(shopifyToast);
  let shopifyToastTimer;

  const showShopifyToast = form => {
    const card = form.closest('.product-card');
    const name = card?.querySelector('.product-info h3, .detail-summary h1')?.textContent?.trim() || 'A termék';
    const color = card?.querySelector('.product-info p')?.textContent?.trim() || '';
    shopifyToast.replaceChildren();
    const tick = document.createElement('span');
    tick.textContent = '✓';
    const copy = document.createElement('div');
    const heading = document.createElement('strong');
    heading.textContent = 'Kosárba került';
    const detail = document.createElement('small');
    detail.textContent = `${name}${color ? ` · ${color}` : ''}`;
    copy.append(heading, detail);
    shopifyToast.append(tick, copy);
    shopifyToast.classList.add('show');
    window.clearTimeout(shopifyToastTimer);
    shopifyToastTimer = window.setTimeout(() => shopifyToast.classList.remove('show'), 2600);
  };

  // Delegation keeps add-to-cart working when Shopify or an app redraws a product section.
  document.addEventListener('submit', async event => {
    const form = event.target.closest('form.product-buy-form');
    if (!form) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const button = form.querySelector('button.cart-add[type="submit"]');
    const variantInput = form.querySelector('input[name="id"]');
    if (!button || button.disabled || !variantInput?.value) return;
    const originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Hozzáadás…';
    try {
      const root = window.Shopify.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest'},
        body: new FormData(form)
      });
      if (!response.ok) {
        const details = await response.json().catch(() => ({}));
        throw new Error(details.description || 'Cart add failed');
      }
      const cartResponse = await fetch(`${root}cart.js`, {headers: {'Accept': 'application/json'}});
      if (!cartResponse.ok) throw new Error('Cart refresh failed');
      const cart = await cartResponse.json();
      document.querySelectorAll('.bag span,.mobile-cart-link span').forEach(badge => {
        badge.textContent = String(cart.item_count);
      });
      showShopifyToast(form);
      button.textContent = 'Kosárban ✓';
      window.setTimeout(() => { button.textContent = originalLabel; button.disabled = false; }, 1300);
    } catch (error) {
      button.textContent = 'Próbáld újra';
      button.disabled = false;
      window.setTimeout(() => { button.textContent = originalLabel; }, 1800);
    }
  }, true);
}

// Keep the standalone preview cart interactive without affecting Shopify.
if (!window.Shopify) {
  const previewCartKey = 'pillanat-preview-cart-items';
  let previewCartItems = [];
  try { previewCartItems = JSON.parse(localStorage.getItem(previewCartKey) || '[]'); } catch { previewCartItems = []; }
  if (!Array.isArray(previewCartItems)) previewCartItems = [];
  const plannerColorNames = {'Púderrózsaszín':'Dusty Rose', 'Bézs':'Champagne', 'Burgundi':'Burgundy'};
  previewCartItems = previewCartItems.map(item => {
    if (!item?.name?.includes('Simply Planned') || !plannerColorNames[item.color]) return item;
    const color = plannerColorNames[item.color];
    return {...item, color, id:`${item.name}|${color}`};
  });
  localStorage.setItem(previewCartKey, JSON.stringify(previewCartItems));

  const previewMoney = value => `${new Intl.NumberFormat('hu-HU').format(value)} Ft`;
  const previewCartCount = () => previewCartItems.reduce((total, item) => total + (Number(item.quantity) || 0), 0);
  const updatePreviewBadges = () => {
    document.querySelectorAll('.bag span,.mobile-cart-link span').forEach(badge => {
      badge.textContent = String(previewCartCount());
    });
  };
  const savePreviewCart = () => {
    localStorage.setItem(previewCartKey, JSON.stringify(previewCartItems));
    updatePreviewBadges();
  };
  const previewToast = document.createElement('button');
  previewToast.type = 'button';
  previewToast.className = 'cart-toast';
  previewToast.setAttribute('aria-label', 'Kosár megnyitása');
  previewToast.setAttribute('aria-live', 'polite');
  document.body.appendChild(previewToast);
  let previewToastTimer;
  const showPreviewToast = card => {
    const name = card?.querySelector('.product-info h3')?.textContent?.trim() || 'A termék';
    const color = card?.querySelector('.product-info p')?.textContent?.trim();
    previewToast.innerHTML = `<span>✓</span><div><strong>Kosárba került</strong><small>${name}${color ? ` · ${color}` : ''}</small></div>`;
    previewToast.classList.add('show');
    window.clearTimeout(previewToastTimer);
    previewToastTimer = window.setTimeout(() => previewToast.classList.remove('show'), 2600);
  };

  updatePreviewBadges();
  document.querySelectorAll('button.cart-add[type="button"]').forEach(button => {
    button.addEventListener('click', () => {
      const card = button.closest('.product-card');
      const name = card?.querySelector('.product-info h3')?.textContent?.trim() || 'Termék';
      const color = card?.querySelector('.product-info p')?.textContent?.trim() || '';
      const price = Number((card?.querySelector('.product-info strong')?.textContent || '0').replace(/\D/g, ''));
      const image = card?.dataset.cartImage || card?.querySelector('.product-image img')?.getAttribute('src') || '';
      const quantity = Math.max(1, Number(card?.querySelector('[data-product-quantity] input')?.value) || 1);
      const id = `${name}|${color}`;
      const existing = previewCartItems.find(item => item.id === id);
      if (existing) existing.quantity += quantity;
      else previewCartItems.push({id, name, color, price, image, quantity});
      savePreviewCart();
      showPreviewToast(card);
      const label = button.textContent;
      button.textContent = 'Kosárban ✓';
      button.classList.add('added');
      window.setTimeout(() => { button.textContent = label; button.classList.remove('added'); }, 1300);
    });
  });

  const previewCartList = document.querySelector('.cart-items');
  const renderPreviewCart = () => {
    if (!previewCartList) return;
    previewCartList.innerHTML = previewCartItems.map((item, index) => `
      <article class="cart-row" data-index="${index}">
        <div class="cart-product"><img src="${item.image}" alt="${item.color} ${item.name}"><div><h2>${item.name}</h2><p>${item.color}</p></div></div>
        <div class="cart-price" data-label="Ár">${previewMoney(item.price)}</div>
        <div class="cart-quantity" data-label="Darabszám"><button type="button" data-preview-cart="minus">−</button><span>${item.quantity}</span><button type="button" data-preview-cart="plus">+</button></div>
        <strong class="cart-line-total" data-label="Összesen">${previewMoney(item.price * item.quantity)}</strong>
        <button class="cart-remove" type="button" data-preview-cart="remove" aria-label="${item.name} eltávolítása">×</button>
      </article>`).join('');
    const empty = previewCartItems.length === 0;
    document.querySelector('.cart-empty')?.toggleAttribute('hidden', !empty);
    document.querySelector('.cart-summary')?.toggleAttribute('hidden', empty);
    const checkout = document.querySelector('.cart-checkout');
    if (checkout) checkout.disabled = empty;
    const total = previewCartItems.reduce((sum, item) => sum + item.price * item.quantity, 0);
    const totalNode = document.querySelector('.cart-total');
    if (totalNode) totalNode.textContent = previewMoney(total);
  };
  previewCartList?.addEventListener('click', event => {
    const button = event.target.closest('[data-preview-cart]');
    const row = button?.closest('.cart-row');
    if (!button || !row) return;
    const index = Number(row.dataset.index);
    if (button.dataset.previewCart === 'plus') previewCartItems[index].quantity += 1;
    if (button.dataset.previewCart === 'minus') {
      if (previewCartItems[index].quantity > 1) previewCartItems[index].quantity -= 1;
      else previewCartItems.splice(index, 1);
    }
    if (button.dataset.previewCart === 'remove') previewCartItems.splice(index, 1);
    savePreviewCart();
    renderPreviewCart();
  });
  renderPreviewCart();
}

// Soft editorial entrances, with product cards staggered from left to right.
(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reducedMotion.matches || !('IntersectionObserver' in window)) return;

  const registered = new Set();
  const registerElement = (element, effect, delay = 0) => {
    if (registered.has(element)) return;
    registered.add(element);
    element.classList.add('scroll-reveal', `scroll-reveal--${effect}`);
    element.style.setProperty('--reveal-delay', `${delay}ms`);
  };
  const register = (selector, effect, step = 0) => {
    document.querySelectorAll(selector).forEach((element, index) => {
      registerElement(element, effect, Math.min(index % 6, 5) * step);
    });
  };

  register('.intro > *, .section-heading > *, .film-copy > *, .about-copy > *, .newsletter > *, .catalog-hero > *, .detail-summary, .legal-document > *, .cart-panel > .eyebrow, .cart-panel > h1, .cart-summary, .cart-actions, .cart-empty > *', 'text', 65);
  document.querySelectorAll('.product-grid').forEach(grid => {
    grid.querySelectorAll(':scope > .product-card').forEach((card, index) => {
      registerElement(card, 'product', Math.min(index, 5) * 120);
    });
  });
  register('.value-strip article, .cart-row, .reviews-panel', 'card', 75);
  register('.film-media, .editorial > img, .product-detail > .product-image, .product-gallery', 'media', 0);
  register('.product-image > span, .detail-highlight, .about-signature', 'accent', 45);

  document.documentElement.classList.add('reveal-ready');
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-revealed');
      observer.unobserve(entry.target);
    });
  }, {threshold: 0.08, rootMargin: '0px 0px -7% 0px'});

  registered.forEach(element => observer.observe(element));
})();
